import { useRef, useState } from "react";

import Actionbar from "src/components/common/actionbar/Authactionbar";
import { Message } from "src/components/common/form/Message";
import useUiuxStore from "src/store/useUiuxStore";


import { useMouseContent } from "src/utils/mouse/mouseContent";

import { SearchSection_EQM2010_R01 } from "./SearchSetion_EQM2010_R01";
import { useEQM2010_R01Store } from "./Store_EQM2010_R01";
import { Table_EQM2010_R01 } from "./Table_EQM2010_R01";
import { AgGridReact } from "ag-grid-react";
import { EQM2010_R01DetailDto, EQM2010_R01HeaderDto } from "./Dto_EQM2010_R01";
import { DetailTable_EQM2010_R01 } from "./DetailTable_EQM2010_R01";
import { Content_EQM2010_R01 } from "./Content_EQM2010_R01";
export const Container_EQM2010_R01 = () => {
    const { 
		allCount,
		initData, 
        selectedEQM2010_R01, // ✅ 선택된 헤더 정보 가져오기
	} = useEQM2010_R01Store();


    const { tabList, setMessage } = useUiuxStore();

	const RESIZER = {
		code: 'EQM2010_R01',
		type: 'width',
		storageKey: 'SAL2020_R01-split-width',
		min: 5,
		max: 80,
		default: 37
	} as const;
	const gridRef = useRef<AgGridReact<EQM2010_R01HeaderDto>>(null);
	const detailGridRef = useRef<AgGridReact<EQM2010_R01DetailDto>>(null);

	const containerRef = useRef<HTMLDivElement>(null);
	const infoRef = useRef<HTMLDivElement>(null);
	const isResizing = useRef(false);

    const { 
		splitValue,
		handleMouseDown,
		handleMouseUp
	} = useMouseContent({
		resizer: RESIZER,
		isResizing,
		containerRef,
		infoRef
	});


    const {
		handleExcelClick,
		fetchData,
		defaultEQM2010_R01DetailRow,
		initContainerData,
		handleCreateClick,
		handleSaveClick,
		handleDeleteClick,
		handleServerDeleteClick,
	} = Content_EQM2010_R01({
		gridRef,
		detailGridRef,
		tabList, setMessage,
		containerRef,
		isResizing,
		
	});


    return (
		<div className="content-container">   
			<Actionbar
				onFetchClick={fetchData}
				onCreateClick={() => {}}
				onDeleteClick={() => {}}
				onSaveClick={handleSaveClick}
				onExcelClick={handleExcelClick}
				onInitClick={initContainerData}
			/>
			
			{/* 검색/필터 영역 */}
			<SearchSection_EQM2010_R01 
				onEnterKeyDown={fetchData}
			/>
			
			<div className="flex-1 flex gap-[4px] p-[12px]" ref={containerRef}>
				<div className="h-full" style={{ width: `${splitValue}%` }}>
					<Table_EQM2010_R01 gridRef={gridRef} handleCreateClick={handleCreateClick} />
				</div> 
				
				{/* 리사이저 */}
				<div
					className="w-[6px] bg-gray-100 cursor-col-resize hover:bg-gray-300"
					onMouseDown={(e) => handleMouseDown('LR', e.nativeEvent)}
				/>
				
					<div className="h-full" style={{ width: `${100 - splitValue}%` }} ref={infoRef}>
					<DetailTable_EQM2010_R01 gridRef={detailGridRef} defaultEQM2010_R01DetailRow={defaultEQM2010_R01DetailRow()} />
				</div>
			</div>
			
			<Message />
		</div>
	);
};

